const PROJECT_PATH = /^\/projects\/([^/]+)/;

/**
 * Reads the `{$projectId}` segment from a project route's pathname. Returns
 * undefined for routes outside `projects/{$projectId}`. For code that cannot
 * use `useProjectId`, for example the Apollo links and the stores.
 */
export const getProjectIdFromPath = (pathname: string): string | undefined =>
  PROJECT_PATH.exec(pathname)?.[1];
